import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function TermsPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-3271">
      <Navbar data-id="element-3272" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-3273">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-3274">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-3275" />
          <span data-id="element-3276">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-3277">
          <div className="flex items-center gap-4 mb-8" data-id="element-3278">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-3279">
              <FileText className="w-8 h-8 text-[#4f1964]" data-id="element-3280" />
            </div>
            <div data-id="element-3281">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-3282">
                {isRTL ? 'شروط الخدمة' : 'Terms of Service'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-3283">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-3284">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3285">
                  قبول الشروط
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3286">
                  باستخدام منصة Operines، فإنك توافق على الالتزام بشروط الخدمة
                  هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام
                  خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3287">
                  الفترة التجريبية المجانية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3288">
                  نقدم فترة تجريبية مجانية مدتها <strong data-id="element-3289">7 أيام</strong> لجميع
                  المستخدمين الجدد. خلال هذه الفترة، يمكنك الوصول إلى جميع ميزات
                  المنصة دون أي رسوم. بعد انتهاء الفترة التجريبية، ستحتاج إلى
                  الاشتراك في إحدى خططنا المدفوعة لمواصلة استخدام الخدمة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3290">
                  استخدام الخدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3291">
                  أنت توافق على:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-3292">
                  <li data-id="element-3293">استخدام المنصة للأغراض القانونية فقط</li>
                  <li data-id="element-3294">تقديم معلومات دقيقة وكاملة عند التسجيل</li>
                  <li data-id="element-3295">الحفاظ على أمان حسابك وكلمة المرور</li>
                  <li data-id="element-3296">عدم إساءة استخدام الخدمة أو محاولة اختراقها</li>
                  <li data-id="element-3297">الامتثال لجميع القوانين واللوائح المعمول بها</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3298">
                  الملكية الفكرية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3299">
                  جميع المحتويات والمواد والبرمجيات المتاحة على منصة Operines هي
                  ملكية حصرية لشركة Operines ومحمية بموجب قوانين حقوق النشر
                  والملكية الفكرية.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3300">
                  الدفع والفواتير
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3301">
                  بعد انتهاء الفترة التجريبية، سيتم تحصيل رسوم الاشتراك وفقًا
                  للخطة التي اخترتها. جميع الرسوم غير قابلة للاسترداد ما لم ينص
                  على خلاف ذلك صراحةً.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3302">
                  إنهاء الخدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3303">
                  نحتفظ بالحق في تعليق أو إنهاء حسابك في أي وقت إذا انتهكت هذه
                  الشروط أو انخرطت في سلوك غير قانوني أو ضار.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3304">
                  إخلاء المسؤولية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3305">
                  يتم توفير الخدمة "كما هي" دون أي ضمانات من أي نوع. نحن لا نضمن
                  أن الخدمة ستكون خالية من الأخطاء أو متاحة دون انقطاع.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3306">
                  تحديد المسؤولية
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3307">
                  لن تكون Operines مسؤولة عن أي أضرار غير مباشرة أو عرضية أو
                  خاصة أو تبعية ناتجة عن استخدام أو عدم القدرة على استخدام
                  الخدمة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3308">
                  التغييرات على الشروط
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3309">
                  نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطارك بأي
                  تغييرات جوهرية عبر البريد الإلكتروني أو من خلال المنصة.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3310">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3311">
                  إذا كانت لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا
                  على:
                  <br data-id="element-3312" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-3313">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3314">
                  Acceptance of Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3315">
                  By using the Operines platform, you agree to be bound by these
                  Terms of Service. If you do not agree to these terms, please
                  do not use our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3316">
                  Free Trial Period
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3317">
                  We offer a <strong data-id="element-3318">7-day free trial</strong> for all new
                  users. During this period, you can access all platform
                  features at no cost. After the trial ends, you will need to
                  subscribe to one of our paid plans to continue using the
                  service.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3319">
                  Use of Service
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-3320">
                  You agree to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-3321">
                  <li data-id="element-3322">Use the platform for lawful purposes only</li>
                  <li data-id="element-3323">
                    Provide accurate and complete information when registering
                  </li>
                  <li data-id="element-3324">Maintain the security of your account and password</li>
                  <li data-id="element-3325">Not misuse the service or attempt to hack it</li>
                  <li data-id="element-3326">Comply with all applicable laws and regulations</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3327">
                  Intellectual Property
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3328">
                  All content, materials, and software available on the Operines
                  platform are the exclusive property of Operines and protected
                  by copyright and intellectual property laws.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3329">
                  Payment and Billing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3330">
                  After the trial period ends, subscription fees will be charged
                  according to your chosen plan. All fees are non-refundable
                  unless explicitly stated otherwise.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3331">
                  Service Termination
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3332">
                  We reserve the right to suspend or terminate your account at
                  any time if you violate these terms or engage in illegal or
                  harmful behavior.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3333">
                  Disclaimer
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3334">
                  The service is provided "as is" without warranties of any
                  kind. We do not guarantee that the service will be error-free
                  or available without interruption.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3335">
                  Limitation of Liability
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3336">
                  Operines shall not be liable for any indirect, incidental,
                  special, or consequential damages arising from the use or
                  inability to use the service.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3337">
                  Changes to Terms
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3338">
                  We reserve the right to modify these terms at any time. You
                  will be notified of any material changes via email or through
                  the platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-3339">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-3340">
                  If you have any questions about these Terms of Service, please
                  contact us at:
                  <br data-id="element-3341" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-3342">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}